var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 13.125H10.875V19.875C10.875 20.4954 11.3796 21 12 21C12.6204 21 13.125 20.4954 13.125 19.875V13.125H19.875C20.4954 13.125 21 12.6204 21 12C21 11.3796 20.4954 10.875 19.875 10.875H13.125V4.125C13.125 3.50456 12.6204 3 12 3C11.3796 3 10.875 3.50456 10.875 4.125V10.875H4.125C3.50456 10.875 3 11.3796 3 12C3 12.6204 3.50456 13.125 4.125 13.125Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9ab83e44401f4de6fc4494ea527b5e8a.svg";
export { ForwardRef as ReactComponent };